import { render, staticRenderFns } from "./RecrutementForm.vue?vue&type=template&id=2a0ba01d&scoped=true&"
import script from "./RecrutementForm.vue?vue&type=script&lang=js&"
export * from "./RecrutementForm.vue?vue&type=script&lang=js&"
import style0 from "./RecrutementForm.vue?vue&type=style&index=0&id=2a0ba01d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ba01d",
  null
  
)

export default component.exports